// Base
import axios from "axios";
import { create } from "zustand";

// Types
import type {
  ProductDataStore,
  ProductDataState,
  GetProductParams,
} from "@/types/types";

const initialState: ProductDataState = {
  loading: false,
  success: false,
  error: false,
  errorData: null,
  products: null,
  formatted_string: null,
  shouldUseBundleTitle: false,
  paymentsConfig: null,
  emailMarketingConfig: null,
};

export const useProductData = create<ProductDataStore>((set) => ({
  ...initialState,
  get: async ({
    postId,
    isMobile,
    affParam,
    affSourceParam,
  }: GetProductParams) => {
    set({ ...initialState, loading: true });
    try {
      const productPackEndpoint = "/wp-json/core/products/v1/product_pack/";
      const res = await axios.post(productPackEndpoint, {
        postId,
        isMobile,
        affParam,
        affSourceParam,
      });

      set({
        ...initialState,
        success: true,
        products: res?.data?.products?.products,
        ...res?.data.products,
        formatted_string: res?.data.formatted_string,
        country_code: res?.data?.country?.toUpperCase(),
        paymentsConfig: res?.data?.paymentsConfig,
        emailMarketingConfig: res?.data?.emailMarketingConfig,
      });
    } catch (err: any) {
      set({ ...initialState, error: true, errorData: err.message });
    }
  },
  changeProductsShippingPrice: (shippingPrice: number) => {
    set((state) => ({
      ...state,
      products: state.products
        ? state.products.map((product) => ({
            ...product,
            shipping_price: shippingPrice,
          }))
        : null,
    }));
  },
}));
